import { connect } from 'react-redux';
import { formValueSelector, isInvalid } from 'redux-form';

import LicenseOuterFormComponent from '../components/profile/License/LicenseOuterFormComponent';
import { addLicense, moveLicense, getLicense, changeLicense, removeFacilitiesAction } from '../store/actions/licenses';
import { getCurrentCompany } from './selectors/companySelectors';
import { getCurrentUser } from './selectors/userSelectors';

const LICENSE_FORM_NAME = 'license';

const getSelector = (form) => formValueSelector(form);

const mapStateToProps = (state, { initialValues, platforms, isCreateAction, action, close, toolTipFlag, pageAmount, page, nextPage, prevPage, inProgress, inProgress2, changePlatform, addIncorrectIds, incorrectIds, updateInvalid, savedCallbacks, saveCallbacks, savedAdditional, saveAdditional, updateSubEnabled }) => {
    const form = LICENSE_FORM_NAME + (initialValues && initialValues.env ? `_${initialValues.env}` : '');

    return {
        form,
        subEnabled: getSelector(form)(state, 'subEnabled'),
        selectedPlatform: getSelector(form)(state, 'platform'),
        description: getSelector(form)(state, 'description'),
        formData: getSelector(form)(state, 'name', 'plaform', 'license', 'cosumerKey', 'consumerSecret', 'appCategoryId', 'redirectUrl', 'description'),
        initialValues,
        isCreateAction,
        action,
        platforms,
        user: getCurrentUser(state),
        company: getCurrentCompany(state),
        close,
        toolTipFlag,
        pageAmount,
        page,
        nextPage,
        prevPage,
        inProgress,
        inProgress2,
        changePlatform,
        addIncorrectIds,
        incorrectIds,
        isInvalid: isInvalid(form)(state),
        updateInvalid,
        callbacks: getSelector(form)(state, 'accountCallback', 'manualCallback', 'gpsCallback', 'lifefitnessCallback', 'lfUserLoginCallback', 'lfUserLogoutCallback', 'lfUserWorkoutStartCallback', 'lfUserWorkoutEndCallback', 'workoutdataCallback', 'strengthAssetLoginCallback', 'strengthAssetLogoutCallback', 'strengthResultsCallback', 'assetStatsCallback'),
        additional: getSelector(form)(state, 'assetApiCheckbox', 'forcedLogInCheckbox'),
        savedCallbacks,
        saveCallbacks,
        savedAdditional,
        saveAdditional,
        updateSubEnabled,
    };
};

const mapDispatchToProps = {
    addLicense,
    moveLicense,
    changeLicense,
    removeFacilitiesAction,
}

const mergeProps = (
    { action, user, company, close, isCreateAction, pageAmount, page, nextPage, prevPage, inProgress, inProgress2, changePlatform, initialValues, addIncorrectIds, incorrectIds, updateInvalid, callbacks, additional, facilities, savedAdditional, subEnabled, updateSubEnabled, ...stateProps },
    { addLicense, moveLicense, changeLicense, removeFacilitiesAction },
) => {
    return {
        ...stateProps,
        isCreateAction,
        action,
        onSubmit: (licenseData) => {
            if (page === 1 && pageAmount !== 1) {
                nextPage();
            } else if (page === 2 || pageAmount === 1) {
                let promise;
                let prevPromise;
                let submitAction = isCreateAction ? addLicense : moveLicense;
                let setLicensePromise = getLicense;

                if (licenseData.id === initialValues.id) {
                    licenseData.facilitiesSubscribedFor = initialValues.facilitiesSubscribedFor;
                    licenseData.facilitiesSubscriptionPending = initialValues.facilitiesSubscriptionPending;
                    licenseData.facilitiesSubscriptionRejected = initialValues.facilitiesSubscriptionRejected;
                    licenseData.facilitiesAdded = initialValues.facilitiesAdded;
                    licenseData.assetApi = initialValues.assetApi;
                    licenseData.forcedLogIn = initialValues.forcedLogIn;
                    licenseData['assetApi-active'] = initialValues['assetApi-active'];
                    licenseData['forcedLogIn-active'] = initialValues['forcedLogIn-active'];
                } else {
                    licenseData = {...initialValues};
                }

                if (action === 'editDev' || action === 'editProd') {
                    submitAction = changeLicense;
                }
                prevPromise = setLicensePromise(licenseData.id);

                promise = submitAction({user, company, licenseData});

                if (isCreateAction || action !== 'move') {
                    return promise.then((ids) => {
                        if (ids) {
                            addIncorrectIds(ids);
                        } else {
                            close();
                            removeFacilitiesAction(null, licenseData);
                        }
                    }).finally(() => {
                        licenseData = {};
                    });
                } else {
                    return prevPromise().then(promise.then((ids) => {
                        if (ids) {
                            addIncorrectIds(ids);
                        } else {
                            close();
                        }
                    }).finally(() => {
                        licenseData = {};
                    }));
                }
            }
        },
        page,
        prevPage,
        inProgress,
        inProgress2,
        removeFacilitiesAction,
        changePlatform,
        initialValues,
        incorrectIds,
        addIncorrectIds,
        updateInvalid,
        callbacks,
        additional,
        savedAdditional,
        subEnabled,
        updateSubEnabled,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LicenseOuterFormComponent);



// WEBPACK FOOTER //
// ./src/containers/LicenseOuterFormContainer.js